import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';
import { SignaturePadModule } from 'angular2-signaturepad';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { BuitendienstModule } from 'app/main/buitendienst/module';
import { HomeModule } from 'app/main/home/home.module';
import { HomeKlantModule } from 'app/main/homeKlant/homeKlant.module';
import { MedewerkersModule } from 'app/main/medewerkers/module';
import { OverzichtComponent } from 'app/main/medewerkers/overzicht/overzicht.component';
import { PlanningOverzichtSimpelModule } from 'app/main/planningoverzichtsimpel/planningoverzichtsimpel.module';
import { PlanningOverzichtSimpelKlantModule } from 'app/main/planningoverzichtsimpelKlant/planningoverzichtsimpelKlant.module';
import { PlanningModule } from 'app/main/planning/module';
import { LoginModule } from 'app/main/auth/login/login.module';
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { AppDateAdapter, APP_DATE_FORMATS} from './core/date.adapter';
import {DatePipe} from '@angular/common';
import Core from './core/module';
import { AuthGuard } from 'app/core/services/auth.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from 'app/core/services/auth.interceptor';
import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';

const appRoutes: Routes = [
    {
        path      : '',
        redirectTo:'',
        canActivate: [AuthGuard],
        pathMatch: 'full'
    }, {path:'**', redirectTo:'', canActivate: [AuthGuard]}
];

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY'
    }
};

@NgModule({
    declarations: [
        AppComponent
    ],
    providers: [DatePipe,{
        provide : HTTP_INTERCEPTORS,
        useClass : AuthInterceptor,
        multi : true
      },
      { provide: DateAdapter, useClass: MomentDateAdapter },
{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        //{
        //    provide: DateAdapter, useClass: AppDateAdapter,
        //},
      //  {
      //      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
      //  },
        ...Core.services
        ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, {useHash: true}),
        TranslateModule.forRoot(),
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        // Material moment date module
        MatMomentDateModule,
        // Material
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        SignaturePadModule,
        // App modules
        LayoutModule,
        HomeModule,
        MedewerkersModule,
        PlanningModule,
        PlanningOverzichtSimpelModule,
        PlanningOverzichtSimpelKlantModule,
        BuitendienstModule,
        LoginModule,
        HomeKlantModule
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
